import React, { useState, useEffect, useContext } from "react";
import ChatHistoryServices from "services/ChatHistoryServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import TableLoading from "components/preloader/TableLoading";
import Somethingwentwrong from "pages/Somethingwentwrong";
import DeleteModal from "components/modal/DeleteModal";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import NotFound from "components/table/NotFound";
import { FiRefreshCcw } from "react-icons/fi";
import InputSearchDate from "components/form/InputSearchDate";
import ChatHistoryTable from "components/languageDriver/ChatHistoryTable";

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const ChatHistory = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id;
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { data, loading } = useAsync(() => ChatHistoryServices.getChatByEmpId(id_employee, payload));
  const [status, setStatus] = useState("");
  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
   const [searchText, setSearchText] = useState("");
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formattedDates = {
    start_date: searchstartDate ? formatDate(searchstartDate) : "",
    end_date: searchendDate ? formatDate(searchendDate) : "",
  };

  const payload = {
    from: formattedDates.start_date,
    to: formattedDates.end_date,
  };
  const { title, serviceId } = useToggleDrawer();

  // Contains the column headers and table data in the required format for CSV
  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status, isUpdate]);
 
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "chat history" && perm.view === 1
      );

      const handleSearch = () => {
        setIsUpdate(true);
      };
      // Refresh re-runs the fetch with whatever filters are currently set —
      // it must not clear the selected dates, only reload.
      const handleRefresh = () => {
        setIsUpdate(true);
      };

      const filteredData =
  safeData?.filter((item) =>
    (item.employee_name &&
      item.employee_name.toLowerCase().includes(searchText.toLowerCase())) ||
    (item.agent_name &&
      item.agent_name.toLowerCase().includes(searchText.toLowerCase())) ||
    (item.rating !== undefined &&
      item.rating.toString().includes(searchText.toString())) ||
    (item.chat_id &&
      item.chat_id.toString().includes(searchText.toLowerCase()))
  ) || [];


  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex items-center gap-3">
                <div className="flex-1">
                  <Input
                                     className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                     type="search"
                                     name="search"
                                     autoComplete="off"
                                     value={searchText}
                                     onChange={(e) => setSearchText(e.target.value)}
                                     placeholder="Search"
                                   />
                </div>

                <div className="flex items-center gap-2">
                  <LabelArea label="Start Date" />
                  <div className="w-50">
                    <InputSearchDate
                      value={searchstartDate}
                      onChange={(event) => setSearchStartDate(event)}
                    />
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <LabelArea label="End Date" />
                  <div className="w-50">
                    <InputSearchDate
                      value={searchendDate}
                      min={searchstartDate}
                      onChange={(event) => setSearchEndDate(event)}
                    />
                  </div>
                </div>

                <Button
                  className="rounded-md h-10 px-8"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </Button>

                <div>
                  <FiRefreshCcw
                    onClick={() => {
                      handleRefresh();
                    }}
                  />
                </div>
              </div>
            </CardBody>
          </Card>

          <div className="data-table-container">
            {loading ? (
              // Display a loading spinner or message while data is being fetched
              <TableLoading row={12} col={6} width={190} height={20} />
            ) : status === false || status === undefined ? (
              <Somethingwentwrong title="Something went wrong, please try again later." />
            ) : safeData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-0">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">Chat ID</TableCell>
                      <TableCell className="text-center">Agent Name</TableCell>
                      <TableCell className="text-center">Executive</TableCell>
                      <TableCell className="text-center">Started</TableCell>
                      <TableCell className="text-center">Rating</TableCell>
                      <TableCell className="text-center">Duration</TableCell>
                      <TableCell className="text-center">View</TableCell>
                    </tr>
                  </TableHeader>

                  <ChatHistoryTable historydata={filteredData} />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no Chat History." />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ChatHistory;
